import {
  Directive,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { AUTH_SERVICE, IAuthService } from 'src/app/core/auth/iauth.service';

@Directive({
  selector: '[giq-interaction]',
  standalone: false,
})
export class InteractionDirective implements OnInit, OnDestroy {
  private lastActivity = Date.now();
  private readonly throttleMs = 60000; // 60 seconds throttle
  private touchStartListener?: () => void;

  constructor(
    @Inject(AUTH_SERVICE) private authService: IAuthService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.touchStartListener = () => this.handleInteraction();
    this.elementRef.nativeElement.addEventListener(
      'touchstart',
      this.touchStartListener,
      { passive: true }
    );
  }

  ngOnDestroy(): void {
    if (this.touchStartListener) {
      this.elementRef.nativeElement.removeEventListener(
        'touchstart',
        this.touchStartListener
      );
    }
  }

  private handleInteraction(): void {
    const now = Date.now();
    if (now - this.lastActivity > this.throttleMs) {
      this.lastActivity = now;
      this.authService.refresh();
    }
  }

  @HostListener('click') onClick() {
    this.handleInteraction();
  }

  @HostListener('keydown') onKeyDown() {
    this.handleInteraction();
  }

  @HostListener('input') onInput() {
    this.handleInteraction();
  }
}
